import * as React from "react"

import gsap from "gsap"; // <-- import GSAP
import { useGSAP } from "@gsap/react"; // <-- import the hook from our React package

import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default function Icon() {

  useGSAP(() => {

    let tl = gsap.timeline({
      defaults: {
        duration: 1.2,
        ease: 'power1.inOut',
      },
      scrollTrigger: {
        trigger: "#icon-checkmark",
        start: "bottom bottom-=100px",
        end: "bottom+=50px bottom",
        markers: false,
        toggleActions: "play none play reset"
      }
    });

    tl.to('.checkMarks', { 
        strokeDashoffset: 0,
        stagger: 0.3,
      })
      .to('.lines path', {
        strokeDashoffset: 0,
        stagger: 0.2,
      }, '-=0.5')
  });

 return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 81.71 108.74" id="icon-checkmark">
        <g fill="none" stroke="#001e5d" stroke-linecap="round" stroke-linejoin="round" stroke-width="4">
          <path className="checkMarks" d="m12.64 47.17 5.07 5.07 15.2-15.2" stroke-dasharray="100" stroke-dashoffset="100" />
          <path className="checkMarks" d="m12.64 80.96 5.07 5.07 15.2-15.2" stroke-dasharray="100" stroke-dashoffset="100" />
          <path d="M34.1 8.76C34.1 5.03 37.13 2 40.86 2s6.76 3.03 6.76 6.76"/>
          <g className="lines" stroke-dasharray="100" stroke-dashoffset="100">
            <path d="M44.67 52.3h21.14"/>
            <path d="M44.67 43.86h17.77"/>
            <path d="M44.67 35.41h21.14"/>
            <path d="M44.67 69.2h21.14"/>
            <path d="M44.67 77.64h17.77"/>
            <path d="M44.67 86.09h21.14"/>
          </g>
          <path d="M62.82 13.83h10.14c3.74 0 6.76 3.01 6.76 6.76v79.4c0 3.74-3.01 6.76-6.76 6.76H8.76c-3.74 0-6.76-3.01-6.76-6.76V20.58c0-3.74 3.01-6.76 6.76-6.76H18.9"/>
          <path d="M47.61 8.76h10.14c2.81 0 5.07 2.26 5.07 5.07s-2.26 5.07-5.07 5.07H23.96c-2.81 0-5.07-2.26-5.07-5.07s2.26-5.07 5.07-5.07H34.1"/>
        </g>
      </svg>
 );
}